// Turns any string into a stable hex color so the same tag always gets the same color.
// FNV-1a is just a small hashing trick here: it mixes the characters into a number,
// and we then use that number to build a 6-digit RGB color.
export function stringToHexColor(input: string): string {
  let hash = 0x811c9dc5;

  for (let i = 0; i < input.length; i++) {
    hash ^= input.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }

  const color = (hash >>> 0).toString(16).padStart(8, "0");
  return `#${color.slice(2)}`;
}
